import { render, staticRenderFns } from "./Accommodation.vue?vue&type=template&id=0db5fe80&scoped=true"
import script from "./Accommodation.vue?vue&type=script&lang=js"
export * from "./Accommodation.vue?vue&type=script&lang=js"
import style0 from "./Accommodation.vue?vue&type=style&index=0&id=0db5fe80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5fe80",
  null
  
)

export default component.exports